import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { api } from '../lib/api';
import Input from '../components/Input';
import Button from '../components/Button';

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError(t('auth.passwordMinLength')); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      navigate('/login');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Reset failed');
    } finally { setLoading(false); }
  };

  return (
    <motion.div
      className="max-w-md mx-auto px-6 py-20"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="text-center mb-8">
        <h1 className="font-display text-3xl font-bold mb-2">{t('auth.newPassword')}</h1>
        <p className="text-muted text-sm">{t('auth.newPasswordDesc')}</p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-5">
        {error && <div className="bg-danger/10 border border-danger/30 rounded px-4 py-3 text-sm text-danger">{error}</div>}
        <Input label={t('auth.password')} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus placeholder={t('auth.passwordPlaceholder')} />
        <Button type="submit" disabled={loading} className="w-full" size="lg">
          {loading ? t('auth.updating') : t('auth.updatePassword')}
        </Button>
      </form>
      <p className="text-center text-sm text-muted mt-6">
        <Link to="/login" className="text-primary hover:text-primary-hover">{t('auth.backToLogin')}</Link>
      </p>
    </motion.div>
  );
}
